import { render, staticRenderFns } from "./CardLogs.vue?vue&type=template&id=65738d98&scoped=true&"
import script from "./CardLogs.vue?vue&type=script&lang=js&"
export * from "./CardLogs.vue?vue&type=script&lang=js&"
import style0 from "./CardLogs.vue?vue&type=style&index=0&id=65738d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65738d98",
  null
  
)

export default component.exports